/**
 * Parses pasted addresses using whitespace, commas, or line breaks as separators.
 *
 * @param input - Raw text pasted into the bulk-assignment textarea.
 * @returns Non-empty email tokens, with exact duplicate tokens removed.
 */
export function parseBulkEmails(input: string): string[] {
  return [...new Set(input.split(/[\s,]+/).map((email) => email.trim()).filter(Boolean))];
}
